/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import {useRouter} from 'next/router';

import {Badge} from './Badge';
import Link from './Link';
import {StoryBookIcon} from './svg';
import {createURLWithParams} from '../util';

const ResourceCard = ({
  badge, post, trackerEvent, urlParams,
}) => {
  const router = useRouter();
  const url = `/resources/${post.slug}`;

  const handleClick = () => {
    trackerEvent?.();
    router.push(createURLWithParams(url, urlParams));
  };

  return (
    <div
      onClick={handleClick}
      className="cursor-pointer py-3 px-5 border border-gray-200 rounded-lg hover:border-gray-300 transition duration-50 overflow-hidden"
    >
      <div className="hidden md:flex flex-col w-full">
        {post.thumbnail && (
          <div className="flex relative -mt-3 -mx-5 mb-5 h-36 justify-center items-center bg-gray-100">
            <img
              src={`${post.thumbnail}?w=800&h=800`}
              className="w-full h-full object-cover"
              loading="lazy"
              width="400"
              height="200"
              alt={post.title}
            />
            <div className="absolute inset-0 w-full h-full bg-gray-200 bg-opacity-10" />
            {badge && <Badge className="absolute top-2 right-2">{badge}</Badge>}
          </div>
        )}
      </div>
      <div className="flex flex-col justify-between w-full">
        <Link href={url}>
          <h3 className="my-2 text-lg font-semibold leading-6 text-gray-900">{post.shortTitle}</h3>
        </Link>
      </div>
    </div>
  );
};

export default ResourceCard;
